import { css } from '@emotion/react';
import { memo } from 'react';
import { flex } from '~/modules/AppLayout/FlexGridCss';
import { fontWeight600 } from '~/css/font';
const indexKeyCss = css `
  font-size: 18px;
  ${fontWeight600};
`;
const indexValueCss = css `
  ${flex.h.allCenter};
  width: 22.5%;
  padding: 0 4px;
  border-radius: 4px;
  font-size: 18px;
  ${fontWeight600};
  background-color: #eeeeee;
`;
const detailItemCss = css `
  ${flex.v.default};
  margin: 8px;
  & p {
    margin: 0;
  }
`;
const CustomizedRadarText = memo(function CustomizedRadarText({ data, }) {
    return (<div css={flex.v.mainCenter}>
      {data.map((datum, index) => (<div key={index} css={detailItemCss}>
          <p css={indexKeyCss}>{datum.header}</p>
          <p css={indexValueCss}>
            {datum.value}
            {datum.isPercentage && '%'}
          </p>
        </div>))}
    </div>);
});
export default CustomizedRadarText;
